const PATH = 'fe.pages.testing.reliability.score_report.result_section';

const messages = {
  congratulationsMessage: {
    key: `${PATH}.congratulations_message`,
    defaultValue: 'Congratulations, {{value}}!'
  },
  sorryMessage: {
    key: `${PATH}.sorry_message`,
    defaultValue: `We're sorry, {{value}}!`
  },
  passMessage: {
    key: `${PATH}.pass_message`,
    defaultValue: `<span style="color: #005E26">You passed</span> the `
  },
  notPassMessage: {
    key: `${PATH}.not_pass_message`,
    defaultValue: `Unfortunately you <span style="color: #D01E08">did not pass</span> the `
  },
  videoCriteria: {
    key: `${PATH}.video_criteria`,
    defaultValue:
      'You must correctly code at least 80% of the dimensions across all five videos.'
  },
  scoreBelow: {
    key: `${PATH}.score_below`,
    defaultValue: 'You scored below'
  },
  scoreAtLeast: {
    key: `${PATH}.score_at_least`,
    defaultValue: 'You scored at least'
  },
  twoOfFiveMessage: {
    key: `${PATH}.two_of_five_message`,
    defaultValue:
      'For each dimension, you must correctly code at least two of the five videos.'
  },
  twoOfFiveRule: {
    key: `${PATH}.two_of_five_rule`,
    defaultValue: `You met the <span class='font-bold'>2 of 5</span> rule`
  },
  failTwoOfFiveRule: {
    key: `${PATH}.failed_two_of_five_rule`,
    defaultValue: `You didn't meet the <span class='font-bold'>2 of 5</span> rule`
  },
  attemptTwoAdditionalBefore: {
    key: `${PATH}.attempt_two_additional_before`,
    defaultValue: 'Additionally, please review the resources available on the'
  },
  attemptTwoAdditionalLink: {
    key: `${PATH}.attempt_two_additional_link`,
    defaultValue: 'Reliability Support'
  },
  attemptTwoAdditionalAfter: {
    key: `${PATH}.attempt_two_additional_after`,
    defaultValue:
      'page, including the downloadable age level tip sheet PDF before taking Attempt 3.'
  },
  attemptTip: {
    key: `${PATH}.attempt_tip`,
    defaultValue: 'Attempt tip icon'
  },
  nextSteps: {
    key: `${PATH}.next_steps`,
    defaultValue: 'Participant Next Steps'
  },
  suggestions: {
    key: `${PATH}.suggestions`,
    defaultValue:
      'Training participants will be offered the following suggestions following each test attempt:'
  },
  certification: {
    key: `${PATH}.certification`,
    defaultValue: 'Pass: Access their new certification'
  },
  attemptOne: {
    key: `${PATH}.attempt_one`,
    defaultValue: 'Fail, Attempt 1:'
  },
  support: {
    key: `${PATH}.support`,
    defaultValue: 'Review Reliability Support'
  },
  resources: {
    key: `${PATH}.resources`,
    defaultValue: 'resources.'
  },
  attemptTwo: {
    key: `${PATH}.attempt_two`,
    defaultValue: 'Fail, Attempt 2:'
  },
  schedule: {
    key: `${PATH}.schedule`,
    defaultValue: 'Schedule Reliability Support'
  },
  call: {
    key: `${PATH}.call`,
    defaultValue: 'call with Teachstone.'
  },
  attemptThree: {
    key: `${PATH}.attempt_three`,
    defaultValue: 'Fail, Attempt 3: Register for another Observation Training.'
  },
  eachCategory: {
    key: `${PATH}.each_category`,
    defaultValue:
      'You must correctly answer at least 50% of the questions in each category.'
  },
  categoryAtLeastFifty: {
    key: `${PATH}.category_at_least_fifty`,
    defaultValue: 'Each category at least 50%'
  },
  questionsCorrectly: {
    key: `${PATH}.questions_correctly`,
    defaultValue:
      'You must correctly answer at least 80% of all questions correctly.'
  },
  certifications: {
    key: `${PATH}.certifications`,
    defaultValue: 'Certifications'
  },
  observerNote: {
    key: `${PATH}.observer_note`,
    defaultValue: 'Your observer certification has been renewed.'
  },
  observerKnowledgeTestNote: {
    key: `${PATH}.observer_knowledge_test_note`,
    defaultValue:
      'A new trainer certification is now available on the certifications page.'
  },
  trainerFirstEditionNote: {
    key: `${PATH}.trainer_first_edition_note`,
    defaultValue: 'Your observer and trainer certifications have been renewed.'
  },
  trainerSecondEditionNote: {
    key: `${PATH}.trainer_second_edition_note`,
    defaultValue:
      'Your observer certification has been renewed. To renew your trainer certification, please complete the trainer knowledge test that is now available on the certifications page.'
  }
};

export default messages;
